var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"WrapperResponsiveCenterComponent"},[_c('v-layout',{staticClass:"justify-center align-center pa-2"},[_c('v-flex',{staticClass:"xs12 sm10 md8 lg6"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }